import angular from "angular"

const CURRENT_VIDEO_LIST = {
  "agregar-una-alerta": { title: "Agregar una Alerta", youtubeID: "CiPJ6QgmaYo" },
  "registrar-actividad": {
    title: "Registrar una actividad de acompañamiento",
    youtubeID: "-uAkg-en5kA"
  },
  "ficha-del-estudiante": { title: "Ficha del estudiante", youtubeID: "1iTH32cs8IA" }
}

videosController.$inject = ["$stateParams", "$state", "$sce"]
function videosController($stateParams, $state, $sce) {
  if (!$stateParams.hasOwnProperty("slug") || !CURRENT_VIDEO_LIST[$stateParams.slug]) {
    $state.go("login")
  } else {
    this.currentTitle = CURRENT_VIDEO_LIST[$stateParams.slug]["title"]
    this.currentYoutubeURL = $sce.trustAsResourceUrl(
      "//www.youtube.com/embed/" +
        CURRENT_VIDEO_LIST[$stateParams.slug]["youtubeID"] +
        "?rel=0&autoplay=0&showinfo=0"
    )
  }
}

angular.module("appModule").controller("videosController", videosController)
